<template>
    <div class="bg-[#6d2605]">
        <div class="max-w-screen-xl px-4 py-10 mx-auto lg:py-20">
            <div class="grid items-center grid-cols-12 lg:gap-x-12 gap-y-4">
                <div class="col-span-12 lg:col-span-4 2xl:col-span-4">
                    <nuxt-img :width="personImageWidth" :height="personImageHeight" format="webp" :src="personImageSrc"
                        alt="section image" class="mx-auto" loading="lazy"
                        sizes="xs:297px sm:400px md:389vw lg:388px xl:389px" />
                </div>

                <div class="flex flex-col col-span-12 sm:flex-row gap-y-4 lg:col-span-8 2xl:col-span-8 gap-x-6 ite">
                    <div class="2xl:basis-24 basis-16">
                        <nuxt-img :width="quoteImageWidth" :height="quoteImageHeight" format="webp" :src="quoteImageSrc"
                        alt="section image" class="w-12 mx-auto md:w-auto" loading="lazy"
                        sizes="xs:72px sm:72px md:72px lg:72px xl:72px" />
                    </div>

                    <div class="space-y-6 text-center basis-full md:text-left">
                        <div class="text-white textp" v-html="mainText"></div>

                        <div class="h2 text-[#e7ca66]" v-html="highlightText"></div>

                        <div class="text-white textp" v-html="quoteText"></div>

                        <div class="text-white textp" v-html="authorText"></div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>

const props = defineProps({
    personImageSrc: {
        type: String,
        default: '/assets/images/person-img.png'
    },
    personImageWidth: {
        type: Number,
        default: 389
    },
    personImageHeight: {
        type: Number,
        default: 319
    },
    quoteImageSrc: {
        type: String,
        default: '/assets/images/quote.png'
    },
    quoteImageWidth: {
        type: Number,
        default: 72
    },
    quoteImageHeight: {
        type: Number,
        default: 69
    },
    mainText: {
        type: String,
        default: `I have a big sweet tooth. When I'm looking for something to satisfy this craving during the day or after a meal, I make a cup of Lifeboost's Specialty Flavored Coffee and add a couple tablespoons of organic heavy whipping cream.`
    },
    highlightText: {
        type: String,
        default: 'You have one of the most delicious healthy treats on the planet.'
    },
    quoteText: {
        type: String,
        default: `It's quite possibly heaven in a cup"`
    },
    authorText: {
        type: String,
        default: '- DR. Charles Livingston DC'
    }
});

defineBuilderComponent({
    friendlyName: 'Background Image with Quote',
    inputs: [
        {
            name: 'personImageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png'],
            defaultValue: '/assets/images/person-img.png'
        },
        {
            name: 'personImageWidth',
            type: 'number',
            defaultValue: 389
        },
        {
            name: 'personImageHeight',
            type: 'number',
            defaultValue: 319
        },
        {
            name: 'quoteImageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png'],
            defaultValue: '/assets/images/quote.png'
        },
        {
            name: 'quoteImageWidth',
            type: 'number',
            defaultValue: 72
        },
        {
            name: 'quoteImageHeight',
            type: 'number',
            defaultValue: 69
        },
        {
            name: 'mainText',
            type: 'richText',
            defaultValue: `I have a big sweet tooth. When I'm looking for something to satisfy this craving during the day or after a meal, I make a cup of Lifeboost's Specialty Flavored Coffee and add a couple tablespoons of organic heavy whipping cream.`
        },
        {
            name: 'highlightText',
            type: 'richText',
            defaultValue: 'You have one of the most delicious healthy treats on the planet.'
        },
        {
            name: 'quoteText',
            type: 'richText',
            defaultValue: `It's quite possibly heaven in a cup"`
        },
        {
            name: 'authorText',
            type: 'richText',
            defaultValue: '- DR. Charles Livingston DC'
        }
    ]
});
</script>
